import { hasValue } from 'utils/hasValue';

import type { ErrorAttributes } from 'api';

export const extractUploadErrorMessage = <
  TError extends { error: ErrorAttributes }
>(
  err: TError | null | undefined
): string | null => {
  const msg = err?.error.attributes.content;

  return hasValue(msg) ? msg : null;
};
